import styled from "styled-components";

const Container = styled.div`
  height: 30px;
  background-color: teal;
  color: white;
  display: flex;
  justify-content: center;
  font-weight: 500;
  align-items: center;
  font-style: 14px;
`;

const Announcement = () => {
  return <Container>Super Deal ! free Shipping on Orders Over 50$</Container>;
};

export default Announcement;
